export class CluDoMoreParams {
    DOSSIER_ITEM : CluDoMoreParams_DossierItem;
    TIERS_ITEM : CluDoMoreParams_TiersItem;
}

export class CluDoMoreParams_DossierItem {
    D_RAISONSOC : string;
    D_PROFESSION : string;
    D_ADRESSE : string;
    D_COMPLEMENT : string;
    D_CODEPOSTAL : string;
    D_VILLE : string;
    D_CODEREGION : string;
    D_PAYS : string;
    D_EMAIL : string;
    D_TELEPHONE : string;
    D_TELECOPIE : string;
    D_SITE : string;
    D_SIRET : string;
    D_APE : string;
    D_IDENTIFIANT : string;
    D_RCS : string;
}

export class CluDoMoreParams_TiersItem {
    CT_NUM : string;
    N_CATTARIFLIB : string;
    N_CATCOMPTALIB : string;
    CT_IDENTIFIANT : string;
    CT_APE : string;
    CT_SIRET : string;
    CT_TELEPHONE : string;
    CT_TELECOPIE  : string;
    CT_EMAIL : string;
    CT_SITE  : string;
    CT_ADRESSE  : string;
    CT_COMPLEMENT  : string;
    CT_VILLE  : string;
    CT_PAYS  : string;
    CT_CODEPOSTAL  : string;
    CT_CODEREGION  : string;
    CO_NOLIB  : string;
    CT_QUALITE : string;
}
